<div class="header">
  <div class="object-name">
    {{ attributes.name }}
  </div>
  <div class="sub-header">
    {{ attributes.boundaryClassDescription }}
  </div>
</div>
<div class="info-container">
  @if (attributes.airspaceDesignator) {
    <div class="info">
      <p class="field-title">Airspace Designator</p>
      {{ attributes.airspaceDesignator }}
    </div>
  }
  @if (attributes.airspaceTypeDescription) {
    <div class="info">
      <p class="field-title">Airspace Type Description</p>
      {{ attributes.airspaceTypeDescription }}
    </div>
  }
  @if (attributes.controlledBy) {
    <div class="info">
      <p class="field-title">Airspace Controlled By</p>
      {{ attributes.controlledBy }}
    </div>
  }
  @if (attributes.clearanceApprovalAgency) {
    <div class="info">
      <p class="field-title">Clearance Approval Agency</p>
      {{ attributes.clearanceApprovalAgency }}
    </div>
  }
  @if (attributes.lowerLimit) {
    <div class="info">
      <p class="field-title">Lower Limit</p>
      {{ attributes.lowerLimit }}
    </div>
  }
  @if (attributes.upperLimit) {
    <div class="info">
      <p class="field-title">Upper Limit</p>
      {{ attributes.upperLimit }}
    </div>
  }
  @if (attributes.timesOfOperation) {
    <div class="info">
      <p class="field-title">Times of Operation</p>
      {{ attributes.timesOfOperation }}
    </div>
  }
</div>
